import React, { useEffect, useState } from "react";

interface IProps {
    length: number;
    value: string;
    setState: (value: string) => void; 
}

function OTPInput(props: IProps) {
    const refs: React.RefObject<HTMLInputElement>[] = [];
    const initialValue: string[] = [];
    for (let i = 0; i < props.length; i++) {
        initialValue.push(i < props.value.length ? props.value[i] : "");
        refs[i] = React.createRef();
    }
    const [values, setValues] = useState(initialValue);
    useEffect(() => {
        refs[0].current.focus();
    }, []);
    const renderInputs = (val: string, idx: number) => {
        return (
            <input
                key={"inp_" + idx} 
                ref={refs[idx]}
                value={val}
                onInput={(ev: any) => {
                    const newValue = [...values];
                    newValue[idx] = ev.target.value;
                    if ((idx + 1 < refs.length)) {
                        setValues(newValue);
                        refs[idx + 1].current.focus();
                    } else {
                        setValues(newValue);
                        props.setState(newValue.join(""));
                        // refs[0].current.focus();
                    }
                }}
                onFocus={(ev: any) => ev.target.select()}
                maxLength={1}
            />
        );
    };
    return (
        <div className="otp_input">
            {values.map(renderInputs)}
        </div>
    );
}
export default OTPInput;
// .otp_input input {
//     width: 1.5rem;
//     text-align: center;
//     margin-left: .2rem;
//     border-radius: .2rem;
// }